const EVehicleType = {
  OUTSIDE_BROADCAST_VAN: 'entity.specialrequest.vehicleTypes.outsidebroadcastvan',
  SNG_VEHICULE: 'entity.specialrequest.vehicleTypes.sngvehicle',
  CAR: 'entity.specialrequest.vehicleTypes.car',
  MOTOCYCLE: 'entity.specialrequest.vehicleTypes.motorbike',
  AIRCRAFT: 'entity.specialrequest.vehicleTypes.plane',
  HELICOPTER: 'entity.specialrequest.vehicleTypes.helicopter',
  BOAT: 'entity.specialrequest.vehicleTypes.boat',
  DRONE: 'entity.specialrequest.vehicleTypes.drone',
  OTHER_AND_SPECIFY: 'entity.specialrequest.vehicleTypes.other',
  DEFAULT: ''
}

export default EVehicleType;
